// extracted by mini-css-extract-plugin
export default {"sharePageActions":"SharePage_sharePageActions__HnVA-"};